import React, { useState, useEffect } from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";

import "../FoodDatabase.scss";
import PatientFoodItemTabs from "./patientFoodItemTabs";
import AddFoodItemTabs from "./addFoodItemTabs";

const AddFoodItem = ({ match, isAdmin, history }) => {
	const [foodId, setFoodId] = useState(null);
	const [isView, setIsView] = useState(false);

	useEffect(() => {
		if (match && match.params && match.params.id) {
			setFoodId(match.params.id);
		}
		if (history.location.state) {
			if (history.location.state.isViewOnly) {
				setIsView(isAdmin ? false : true)
			}
		}

	}, [match]);

	const isAdding = match && match.path.indexOf("/add") > -1 ? true : false;
	const approval = match && match.path.indexOf("/approval") > -1 ? true : false;

	return (
		<section className="page page-add-food-item">
			<div className="container">
				<h3 className="m-0 mt-2"> {isAdding ? "Add" : isView ? "View" : "Edit"} Food Item</h3>
				<div className="card-wrap">
					<div className="add-food-item-tab-container tab-primary card card-primary w-100">
						{approval ? (
							<PatientFoodItemTabs foodId={foodId} isAdmin={isAdmin} />
						) : (
							<AddFoodItemTabs foodId={foodId} isAdmin={isAdmin} isView={isView} isAdding={isAdding} />
						)}

					</div>
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Auth } = state;
	return {
		isAdmin: Auth.isAdmin,
	};
};

export default reduxForm({
	form: "AddFoodItem",
})(connect(mapStateToProps)(AddFoodItem));
